// extracted by mini-css-extract-plugin
export default {"container":"qYkqJc","noWrapContainer":"JYlsTZ","logo":"vhAyuw","infoButton":"OYsZnL","dark":"TCzQah","light":"fL0cIq"};